<template>
    <div>
      
    <div class="col-md-4 col-sm-5 mt-4 p-2  font-weight-bold" >
                <img :src="head" style="max-width:100px">
        </div> 
        <!-- BOOK SLIDER  -->
        <baseCarousel v-bind:books="books"></baseCarousel>

         <div class="col-md-4 col-sm-5 p-2 font-weight-bold mb-3 button-link">
                <a href="" class="no-underline text-white">{{base}}</a>
        </div> 
    </div>
</template>

<script>
import baseCarousel from "./base-carousel.vue";

    export default { 
        name:"bookSlider_logotop", 
        components:{
            baseCarousel
        },
        props:{
            head:{type:String,required:true},
            base:{type:String,required:true},
            books:{type:Array,required:true},
            styleTop:{type:Object,required:true},
            styleBottom:{type:Object,required:true}
        },
        data(){
            return { 

            }
        },
      
    }
</script>

<style scoped>
     .no-underline{
         text-decoration: none !important ;
     }
</style>




// WEBPACK FOOTER //
// src/components/overall_layouts/book-slider-logotop.vue